<style scoped lang="scss">
  @import '~@/assets/styles/vars';
  @import '~@/assets/styles/theme';

  // main/general
  main {
    font-family: $ff_basic;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
  section {
    margin-bottom: 1rem;
    overflow: hidden;
    padding: 1rem;
  }
  .temp-button {
    display: block;
    width: 120px;
    margin-left: auto;
    margin-right: auto;
    padding: 0.8rem;
  }

  // music data field
  .music-info-area {
    border: 2px solid #263030;
  }
  .music-table {
    opacity: 0.9;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 765px;
    th,td {
      padding: 0.5rem;
    }
    th {
      width: 30%;
    }
  }

  // input field
  .data-input-field {
    li {
      margin-bottom: 1.6rem;
    }
  }
  .input-text {
    width: 100%;
    max-width: 540px;
    min-width: 120px;
    font-size: 0.9rem;
    height: 2rem;
    border: none;
    padding: 0.6rem;
  }

  // output field
  .command-list {
    margin-bottom: 0.5rem;
    li {
      @extend .t-purple-s_hover;
      transition: all ease 0.2s;
      display: inline-block;
      border-width: 1px;
      border-style: solid;
      border-radius: 3px;
      padding: 2px 4px;
      margin-right: 0.5rem;
      font-size: 1.5rem;
      cursor: pointer;
      width: 3rem;
    }
  }
  .textarea {
    width: 100%;
    font-size: 0.9rem;
    height: 140px;
  }
  .icon::before {
    padding: 0 0.3rem;
  }

  // info list
  ol {
    text-align: left;
    margin-left: 1.1rem;
    li {
      padding: 0.5rem;
    }
    list-style: decimal;
  }

  .load-message {
    margin: 1rem;
    font-size: 1.2rem;
    animation: flash 1s infinite;
    @keyframes flash {
      50%{
        opacity: 0;
      }
    }
  }
</style>



<template lang="pug">
.scope
  p-header
  main(role="main")
    h2.p-topic.u-mb-sm PxB Share Player

    section.t-moon--grad.music-info-area(v-if="currentProjectObj")
      h3.p-topic_small MUSIC
      table.music-table.u-mb-sm
        tr(v-for="(value, key, index) in musicData")
          th.t-moon {{key.toUpperCase()}}
          td.t-lightgreen {{value}}
      actbutton(
        :width="240"
        label="PLAY"
        :inactive="!isSimRunnable"
        @push="bootSimApp"
      )
      div(v-if="musicStatusMessage").load-message {{musicStatusMessage}}

    section.t-pastelgreen-b
      h3.p-topic_small PROJECT SET UP
      ul.data-input-field
        li
          h4 MUSIC
          input.input-text.t-moon--dark(
            ref="musicSrcInput"
            type="url"
            placeholder="音源(mp3)のアップロード先URLを入力"
          )
        li
          h4 PxB PROJECT
          input.input-text.t-moon--dark(
            ref="projectInput"
            type="url"
            placeholder="pxbpファイルのアップロード先URLを入力"
          )
        li
          actbutton(
            :width="240"
            label="SET UP"
            :inactive="isCreatingLink"
            @push="createShareLink"
          )

      div(v-if="isCreatingLink").load-message Creating Link...
      section.t-purple.neutralize-anchor(v-if="shareLinkURL !== ''")
        ul.command-list
          li(@click="onClickCopy" title="copy")
            i.icon.ion-ios-copy
          //- li
          //-   a(:href="twitterShareURL" target="_new" title="twitter")
          //-     i.icon.ion-social-twitter
        textarea(
          ref="shareURLtextArea"
          :value="shareLinkURL"
          class="textarea"
          readonly
        )

      section.t-moon
        h3.p-topic_small HOW TO SET UP
        ol.u-mb-sm
          li
            a(href="https://www.dropbox.com/" target="_new") Dropbox
            |のアカウントを作ります（無料）
          li 音源ファイル（mp3のみ）とpxbpファイルをdropboxにアップロードします
          li それぞれのファイルで「共有」→「リンクの作成」でURLを取得します
          li 取得したURLをそれぞれペーストし、「SET UP」を押します
          li うまくいけば楽曲情報が表示され、「PLAY」で実際に遊ぶことができるようになります
          li 同時に専用URLが生成されます。アクセスすると上記の音源・譜面を読み込んだ状態までセットアップを行います
        .t-moon--dark
          |※試験的な機能です。Dropboxの機嫌次第でいきなり使えなくなるかも知れません
</template>



<script>
import {PROJECT_EXT} from '@/Const'
import {getBase64ConvertedString, createTwitterShareLink} from '@/Utils'
import swal from 'sweetalert'
const SHARE_HASH_TAGS = ["pxb_playground"];
const _validateMusicSrc = (musicSrc)=> { return /\.mp3$/.test(musicSrc); };
const _validateProjectSrc = (src)=> {
  const regexp = new RegExp('\.' + PROJECT_EXT + '$');
  return regexp.test(src);
};
const _replaceURL = (urlString)=> {
  // クエリパラメータ省く＆dropbox直リンクを得る
  return urlString.replace(/\?.*$/, "").replace('www.dropbox', 'dl.dropboxusercontent')
};
const errorHandler = (error)=> {
  if (typeof error === 'string') {
    swal(error);
  } else {
    if (error.message && error.message.match(/JSON/)) {
      swal("INVALID PROJECT", "不正なpxbpファイルです", "error");
    } else if (error.text) {
      swal(error);
    }
  }
};
import pHeader from '@/components/Header';
import actbutton from '@/components/sub/ActivationButton';

export default {
  name: 'template',
  components: {
    pHeader,
    actbutton,
  },

  data() {
    return {
      isParsing: false,
      isCreatingLink: false,
      shareLinkURL: "",
      // shareLinkURL: "for debugging",
      musicStatusMessage: "",
      // twitterShareURL: "",
      cachedMusicSrc: "",
      cachedProjectSrc: "",
      currentMusic: null,
      currentProjectSrc: null, // string
      currentProjectObj: null, // Object
    }
  },
  computed: {
    musicData() {
      const params = this.currentProjectObj || {};
      return {
        name: params.musicName || "--",
        artist: params.artistName || "--",
        level: params.musicLevel || "--",
        category: params.category.toUpperCase() || "--",
      }
    },
    isSimRunnable() {
      return (this.currentMusic != null) && (this.currentProjectSrc != null);
    },
  },

  methods: {
    /**
     * 音源読み込み
     * @param  {String} src
     * @return {Promise}
     */
    _loadMusic(src) {
      // from pxb-core holwer
      if (window.Howl) {
        return new Promise((resolve, reject)=> {
          const _music = new Howl({ src: [src] });
          this.musicStatusMessage = "Loading Music..."
          _music.once('load', ()=> {
            this.musicStatusMessage = "";
            this.currentMusic = _music;
            resolve();
          });
          _music.on('loaderror', ()=> {
            this.musicStatusMessage = "";
            reject({
              title: "MUSIC LOAD ERROR",
              text: "音楽のロードに失敗しました",
              icon: "error",
            });
          });
        });
      } else {
        const audio = new Audio();
        audio.src = src;
        audio.load(); // iosは明示的loadが必要
        return new Promise((resolve, reject)=> {
          audio.onloadeddata = ()=> {
            // console.log('sound loaded');
            this.currentMusic = src;
            resolve(src);
          };
          audio.onerror = (e)=> {
            reject({
              title: "MUSIC LOAD ERROR",
              text: "音楽のロードに失敗しました",
              icon: "error",
            });
          };
        });
      }
    },
    /**
     * プロジェクト読み込み
     * @param  {String} src
     * @return {Promise}
     */
    _loadProject(src) {
      return fetch(src).then(response => {
        // if (true) {
        if (!response.ok) {
          throw {
            title: "SERVER RESPONSE ERROR",
            text: "プロジェクトファイル取得に失敗しました",
            icon: "error",
            _message: response.text,
          };
        }
        return response.json();
      })
      .then(json => {
        this.currentProjectSrc = src;
        this.currentProjectObj = json;
      });
    },
    /**
     * プロジェクトのセットアップ
     * @param  {String} musicSrc
     * @param  {String} projectSrc
     * @return {Promise}
     */
    setupProject(musicSrc, projectSrc) {
      return Promise.all([
        this._loadMusic(musicSrc),
        this._loadProject(projectSrc),
      ]);
    },

    _createShareURL() {
      this.shareLinkURL = location.href;
      const data = this.musicData;
      const message = `${data.name} / ${data.artist} | Lv:${data.level} | ${data.category}`;
      // this.twitterShareURL = createTwitterShareLink(message, location.href, SHARE_HASH_TAGS);
    },

    /**
     * createShareLink
     * 音楽・プロジェクトURLをbase64エンコード
     * -> クエリパラメータとしたURLを生成
     * @return {void}
     */
    createShareLink() {
      if (this.isCreatingLink || this.isParsing) return;

      let musicSrc = _replaceURL(this.$refs.musicSrcInput.value);
      let projectSrc = _replaceURL(this.$refs.projectInput.value);
      if (!musicSrc || !projectSrc) {
        swal('NO INPUT', '未入力の項目があります', "error");
        return;
      }
      if (!_validateMusicSrc(musicSrc)) {
        swal('MP3 ONLY', 'mp3ファイルを指定して下さい', "error");
        return;
      }
      if (!_validateProjectSrc(projectSrc)) {
        swal('PXBP ONLY', 'Projectには.pxbpファイルを指定して下さい', "error");
        return;
      }

      // キャッシュと比較して値に変更がなければ何もしない
      if (musicSrc === this.cachedMusicSrc && projectSrc === this.cachedProjectSrc) return;

      // console.log("creating link...");
      this.isCreatingLink = true;
      this.cachedMusicSrc = musicSrc;
      this.cachedProjectSrc = projectSrc;

      /* サウンドをテスト+プロジェクト展開 -> base64化 -> シェアURL生成 */
      this.setupProject(musicSrc, projectSrc)
      .then(()=> {
        return Promise.all([
          getBase64ConvertedString(musicSrc),
          getBase64ConvertedString(projectSrc),
        ]);
      })
      .then((values)=> {
        this.isCreatingLink = false;
        const encodedParams = {
          music: values[0],
          project: values[1],
        };

        /* シェアリンク作成 */
        this.$router.replace({ query: encodedParams });
        this._createShareURL();
        // console.log("url length:", location.href.length);
      })
      .catch((err)=> {
        errorHandler(err);
        this.isCreatingLink = false;
      });
    },

    /**
     * parseQueryParams
     * クエリパラメータをパースしてbase64デコード
     * @return {void}
     */
    parseQueryParams() {
      const params = this.$route.query;
      if (params.music == null || params.project == null) {
        // console.log(params, 'no params');
        return;
      };

      /* base64デコード -> サウンドをテスト+プロジェクト展開 */
      this.isParsing = true;
      Promise.all([
        getBase64ConvertedString(params.music, true),
        getBase64ConvertedString(params.project, true),
      ])
      .then((values)=> {
        // console.log("parsed vals", values);
        return this.setupProject(values[0], values[1]);
      })
      .then((res)=> {
        this.isParsing = false;
        // this._createShareURL(); // For debug
      })
      .catch((err)=> {
        errorHandler(err);
        this.isParsing = false;
      });
    },

    onClickCopy() {
      try {
        this.$refs.shareURLtextArea.select();
        document.execCommand("copy");
        swal('COPIED!', 'クリップボードへコピーしました');
      }
      catch (e) {
        swal('COPY FAIL', 'コピーできませんでした。ブラウザが対応していません', "error");
      }
    },

    /* シミュレーター起動 */
    bootSimApp() {
      if (this.currentMusic == null) {
        swal('No Music', '音源がありません', "error");
        return;
      }
      if (this.currentProjectSrc == null) {
        swal('NO PROJECT', 'プロジェクトがありません', "error");
        return;
      }
      this.$pxbSim.run(this.currentMusic, this.currentProjectSrc);
    },
  },

  created() {
    this.parseQueryParams();
  },
}
</script>




// WEBPACK FOOTER //
// src/components/SharePlayer.vue